import styled from "@emotion/styled";
import { Button } from "react-aria-components";

export const LinkButton = styled(Button)`
  display: flex;
  padding: 0;
  border: 0;
  margin: 0;
  outline: 0;
  align-items: center;
  justify-items: center;
  text-decoration: underline;
  cursor: pointer;
`;
